/**
 * Emoji set for the quick-reaction popover. Reactions themselves are stored
 * server-side in `community_message_reactions` (see api/communityView.ts and
 * useReactions / useToggleReaction) — shared across all users, not device-local.
 */
export const EMOJI_SET = ['👍', '🔥', '🎉', '❤️', '😂', '👀'];

/** Aggregate raw reaction rows into per-emoji counts + whether the current user
 *  reacted, ordered by first-seen so the row layout is stable. */
export interface ReactionSummary {
  emoji: string;
  count: number;
  mine: boolean;
}

export function summarizeReactions(
  rows: { emoji: string; user_id: string }[],
  currentUserId: string | null,
): ReactionSummary[] {
  const order: string[] = [];
  const counts = new Map<string, number>();
  const mine = new Set<string>();
  for (const r of rows) {
    if (!counts.has(r.emoji)) order.push(r.emoji);
    counts.set(r.emoji, (counts.get(r.emoji) ?? 0) + 1);
    if (currentUserId && r.user_id === currentUserId) mine.add(r.emoji);
  }
  return order.map((emoji) => ({ emoji, count: counts.get(emoji) ?? 0, mine: mine.has(emoji) }));
}
